module.exports = __webpack_public_path__ + "media/tts_g1_4.56ddaaa3.mp3";